/**
 * Created by Kieran on 27/09/2017.
 */

import axios from 'axios'
import config from '../../config'

/**
 * Useful routes
 * @type {{addProgress: (function(*=): AxiosPromise), postHba1cReading: (function(*=): AxiosPromise), postWeightReading: (function(*=): AxiosPromise)}}
 */
let QuickTrackingApi = {
  /**
   * Adds all tracking types in one go
   * @param model
   * @returns {AxiosPromise}
   */
  addProgress(model) {
    return axios.post(config.apiUrl + 'tracking/addProgress/', model);
  },
  /**
   * Adds hba1c reading
   * @param model
   * @returns {AxiosPromise}
   */
  postHba1cReading(model) {
    return axios.post(config.apiUrl + 'tracking/hba1c/', model)
  },
  /**
   * Adds weight reading
   * @param model
   * @returns {AxiosPromise}
   */
  postWeightReading(model) {
    return axios.post(config.apiUrl + 'tracking/weight/', model)
  }
};

export default QuickTrackingApi;



// WEBPACK FOOTER //
// ./src/api/Tracking/index.js